<form [formGroup]="paramFormOptV5" *ngIf="!readOnly">
  <mat-form-field>
    <input matInput placeholder="ParamA" formControlName="paramA" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamB" formControlName="paramB" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamC" formControlName="paramC" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="WP" formControlName="wp" required type="number">
  </mat-form-field>
  <mat-form-field>
    <mat-select formControlName="type" placeholder="Type">
      <mat-option *ngFor="let typeOptV5 of typesOptV5" [value]="typeOptV5.value">
        {{typeOptV5.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</form>


<form *ngIf="readOnly">
  <mat-form-field class="readonly">
    <input matInput placeholder="ParamA" [value]="paramFormOptV5.value.paramA" [readonly]="true">
  </mat-form-field>
  <mat-form-field class="readonly">
    <input matInput placeholder="ParamB" [value]="paramFormOptV5.value.paramB" [readonly]="true">
  </mat-form-field>
  <mat-form-field class="readonly">
    <input matInput placeholder="ParamC" [value]="paramFormOptV5.value.paramC" [readonly]="true">
  </mat-form-field>
  <mat-form-field class="readonly">
    <input matInput placeholder="WP" [value]="paramFormOptV5.value.wp" [readonly]="true">
  </mat-form-field>
  <mat-form-field class="readonly">
    <input matInput placeholder="Type" [value]="paramFormOptV5.value.type" [readonly]="true">
  </mat-form-field>
</form>